<label for="Campos obrigatórios" style="color:#DB3347"><span class="mandatory"></span>{{'Workflow.Mandatory' | translate}}</label>

<div class="col-sm-12">
  <h1 class="text-primary mb-4">{{'WorkflowCreatePM.PreStage.CardIdentificacaoServico.Title' | translate}}</h1>
</div>

<h2>{{'WorkflowCreatePM.PreStage.CardIdentificacaoServico.SubTitle' | translate}}</h2>
<div class="row">
  <div class="col-sm-4">
    <div class="form-group">
      <label class="disabled" for="code"><span class="mandatory">*</span>{{'CardServiceIdentification.Code' | translate}}</label>
      <input class="form-control" type="text" numeric="7" placeholder="{{'CardServiceIdentification.Code' | translate}}" [(ngModel)]="model.serviceCode"
             name="code" #code="ngModel" disabled>
      <validation-message [control]="code"></validation-message>
    </div>
  </div>
  <div class="col-sm-8">
    <div class="form-group">
      <label class="disabled" for="designation"><span class="mandatory">*</span>{{'CardServiceIdentification.Designation' | translate}}</label>
      <input class="form-control" placeholder="{{'CardServiceIdentification.Designation' | translate}}"
             [(ngModel)]="model.serviceDesignation" name="designation" #designation="ngModel" maxlength="60" disabled>
      <validation-message [control]="designation"></validation-message>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-sm-4">
    <div class="form-group">
      <fieldset disabled required>
        <label for="NIF" class="disabled"><span class="mandatory">*</span>{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.NIF' | translate}}</label>
        <input class="form-control"
               type="number"
               numeric="9"
               [(ngModel)]="model.NIF"
               name="NIF"
               #NIF="ngModel"
               maxlength="9"
               [required]="model.hasNIFPT?.toString()==='true'">
        <validation-message [control]="NIF"></validation-message>
      </fieldset>
    </div>
  </div>
</div>
<!--<pre>{{cardData | json}}</pre>-->
